<template>
  <span class="line-tokens">
    <template v-for="token in tokens">
      <sup :key="token.pos" v-if="debug">{{ token.pos }}</sup>
      <LineToken :key="token.pos" :token="token" />
      {{ space }}
    </template>
  </span>
</template>

<script>
  import LineToken from './LineToken.vue';

  export default {
    components: { LineToken },
    props: ['tokens', 'debug'],
    computed: {
      space() {
        return ' ';
      },
    },
  };
</script>
